import { render, staticRenderFns } from "./OrderStatusTag.vue?vue&type=template&id=00234758&"
import script from "./OrderStatusTag.vue?vue&type=script&lang=js&"
export * from "./OrderStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports